import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-master_economia',
  templateUrl: './master_economia.component.html',
  styleUrls: ['./master_economia.component.css']
})
export class Master_economiaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
